import CustomButton from "../CustomButton/CustomButton";
import classes from "./NoticeBoardSmall.module.css";

const NoticeBoardSmall = () => {
  return (
    <div className={classes.noticeBoardSmall}>
      <div className={classes.notice_body}>
        <div className={classes.title}>Welcome to the Backrooms!</div>
      
     
             New patrons, please head to the Help page for orientation...
         
        
      </div>
    </div>
  );
};

export default NoticeBoardSmall;
